import clientDetailReducer from './clientDetailReducer';

export default clientDetailReducer;